import React from "react";
import { Shield, Users, BarChart3 } from "lucide-react";

/**
 * TabNavigation component for Field Configuration
 * Displays tabs for Licenses, Roles, and Users
 * @param {Object} props
 * @param {string} props.activeTab - Currently active tab ('licenses', 'roles', or 'users')
 * @param {Function} props.onTabChange - Callback when tab is clicked, receives tab key
 */
export default function TabNavigation({ activeTab, onTabChange, allowedTabs }) {
  const allTabs = [
    { key: "licenses", label: "Licenses", icon: BarChart3 },
    { key: "roles", label: "Roles", icon: Shield },
    { key: "users", label: "Users", icon: Users },
  ];

  const tabs = allowedTabs
    ? allTabs.filter((tab) => allowedTabs.includes(tab.key))
    : allTabs;

  return (
    <div className="field-configuration__tabs">
      {tabs.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          onClick={() => onTabChange(key)}
          className={`field-configuration__tab ${
            activeTab === key ? "field-configuration__tab--active" : ""
          }`}
        >
          <Icon size={18} />
          {label}
        </button>
      ))}
    </div>
  );
}
